import React, { Component } from 'react';
import { StyledBylaws } from './BylawsPage.style';

export default class BylawsPage extends Component {
    render() {
        return (
            <StyledBylaws>
                <h2>
                    Las Palmas Grand Residents' Association Bylaws
                </h2>
                <h3>
                    ARTICLE I - NAME
                </h3>
                <h4>
                    Section 1.
                </h4>
                <section>
                    The name of the association shall be Las Palmas Grand Residents Association, Mesa, AZ., hereafter referred to as LPGRA.
                </section>
                <h3>
                    ARTICLE II - PURPOSE
                </h3>
                <h4>
                    Section 1.
                </h4>
                <section>
                    The LPGRA’s purpose is to provide Residents a voice to LPG Management. LPGRA shall maintain its “Charter Park” status as an affiliate in the Arizona Association of Manufactured Home Owners (AAMHO).  Although LPGRA members are not required to join AAMHO, the board shall encourage membership in the State-wide organization.
                </section>
                <h3>
                    ARTICLE III - MEMBERS
                </h3>
                <h4>
                    Section 1.
                </h4>
                <section>
                    All home owners of Las Palmas Grand are members of LPGRA. 
                </section>
                <h3>
                    ARTICLE IV - BOARD OF DIRECTORS (OFFICERS)
                </h3>
                <h4>
                    Section 1.
                </h4>
                <section>
                    A Board of Directors shall be elected annually in accordance with Section 3 of this Article. This Board shall represent the members of the association, and cooperatively interact with Las Palmas Grand management in carrying out established policies and procedures. The Board shall work to enhance rapport between members and LPG management by prompt action on matters of community-wide interest that are brought before the Board.
                </section>
                <h4>
                    Section 2.
                </h4>
                <section>
                    The Board of Directors shall be comprised of at least five (5) members. The elected positions are President,  1st. Vice-President,  2nd. Vice-President, Secretary, and Treasurer. These positions are the Chairs of the three (3) Standing committees.
                </section>
                <h4>
                    Section 3.
                </h4>
                <section>
                    Each elected Board member shall serve for two (2) years. Two (2) Board members shall be elected in odd years and three (3) Board members shall be elected in even years. To maintain continuity of leadership the President and 1st. Vice President shall be on separate terms. At the first Board meeting following the election, the Board shall decide among themselves as to the Board positions that each Board member will have.
                </section>
                <h4>
                    Section 4.
                </h4>
                <section>
                    Any member of the Board is eligible for re-election. However, no Board member may serve in the same capacity for more than two (2) consecutive terms.  In case of a vacancy on the Board, the remaining members of the Board may appoint a person from the general membership to fill the unexpired term.
                </section>
                <h4>
                    Section 5.
                </h4>
                <section>
                    Election of the Board shall be held each November, at a time and place selected by the Board. New Board members will take office on the first of December following their election.
                </section>
                <h4>
                    Section 6.
                </h4>
                <section>
                    Any member of the LPGRA may vote in person or by absentee ballot upon written request. All absentee ballots may be obtained fifteen (15) days prior to the general meeting in November and filed with the Secretary of the Board no later than twenty-four (24) hours prior to the meeting.
                </section>
                <h4>
                    Section 7.
                </h4>
                <section>
                    Any member of the Board who has three (3) consecutive unexcused absences from meetings of the Board may be removed from the Board by a majority vote of the Board and shall be notified in writing.
                </section>
                <h3>
                    ARTICLE V - OFFICER DUTIES
                </h3>
                <h4>
                    Section 1.
                </h4>
                <section>
                    <span>President</span>
                    The President shall preside at all meetings of the association. In addition to his or her duties, he or she shall serve as Sergeant-At-Arms when appropriate. The President shall be responsible for attending (or sending a representative) to all appropriate AAMHO meetings and reporting the results to the membership. 
                </section>
                <h4>
                    Section 2.
                </h4>
                <section>
                    <span>1st Vice President</span>
                    The 1st Vice President shall assume the responsibilities of the President should the President be absent.
                </section>
                <h4>
                    Section 3.
                </h4>
                <section>
                    <span>2nd Vice President</span>
                    The 2nd Vice President shall assume the responsibilities of the 1st Vice President should the 1st Vice President and the President be absent.  The 2nd Vice President shall serve as liaison to other Thesman Communities.
                </section>
                <h4>
                    Section 4.
                </h4>
                <section>
                    <span>Secretary</span>
                    The Secretary shall record the minutes of all association meetings and maintain association files and history.
                </section>
                <h4>
                    Section 5.
                </h4>
                <section>
                    <span>Treasurer</span>
                    The Treasurer shall be responsible for receiving and disbursing all association funds while maintaining proper accounting of same.
                </section>
                <h3>
                    ARTICLE VI - STANDING COMMITTEES
                </h3>
                <h4>
                    Section 1.
                </h4>
                <section>
                    <span>Nominating Committee</span>
                    The Nominating Committee of not less than three (3) or more than five (5) members of the Association shall be appointed each year, two (2) months before the annual meeting, to draw up a slate of candidates willing to serve on the Board of Directors. The Nominating Committee will report the slate of candidates at the October Board meeting.  Each candidate will be asked to prepare a bio of themselves to be presented at the November general meetings before the elections are conducted.  
                </section>
                <h4>
                    Section 2.
                </h4>
                <section>
                    <span>Communications Committee</span>
                    The Communications Committee of not less than three (3) nor more than five (5) members of LPGRA shall be appointed each year for the purpose of providing information to the entire community.
                </section>
                <h4>
                    Section 3.
                </h4>
                <section>
                    <span>Community Relations Committee</span>
                    The Community Relations Committee of not less than three (3) nor more than seven (7) members of LPGRA shall be appointed each year for the purpose of enhancing rapport and to protect and improve the quality of life enjoyed by residents of Las Palmas Grand.
                </section>
                <h3>
                    ARTICLE VII - MEETINGS
                </h3>
                <h4>
                    Section 1.
                </h4>
                <section>
                    <span>Quorum</span>
                    Is defined as a simple majority of the average meeting attendance.
                </section>
                <h4>
                    Section 2.
                </h4>
                <section>
                    <span>Annual Meeting</span>
                    The LPGRA shall hold an annual meeting during the month of November, at a date and time set by the Board of Directors. Business at this meeting shall include the election of Board members for the ensuing year.
                </section>
                <h4>
                    Section 3.
                </h4>
                <section>
                    <span>General Meetings</span>
                    General Meetings of the members shall be held at least quarterly and as needed.  General Meetings are usually held at 10 a.m. on the first (1st.) Thursday of the month following the Java meeting.
                </section>
                <h4>
                    Section 4.
                </h4>
                <section>
                    <span>Board of Directors Meetings</span>
                    The Board of Directors shall hold monthly meetings and as needed.  These meetings will usually be held at 10 a.m. on the third (3rd.) Thursday of the month.
                </section>
                <h4>
                    Section 5.
                </h4>
                <section>
                    <span>Special Meetings</span>
                    The President, Board of Directors or twenty-five  (25) percent of the average meeting attendance may call a Special Meeting at any time.
                </section>
                <h4>
                    Section 6.
                </h4>
                <section>
                    At any Board Meeting, a simple majority shall be considered a quorum. At each Annual Meeting, General Meeting, and Special Meeting, a simple majority shall be a quorum.
                </section>
                <h4>
                    Section 7.
                </h4>
                <section>
                    <span>Attendance</span>
                    All Annual, General and Special Meetings shall be open to all residents of Las Palmas Grand. 
                </section>
                <h4>
                    Section 8.
                </h4>
                <section>
                    <span>Rules of Order</span>
                    The usual Parliamentary rules as laid down in “Roberts Rules of Order” shall govern all deliberations, when not in conflict with these bylaws. 
                </section>
                <h3>
                    ARTICLE VIII - AMENDMENTS
                </h3>
                <h4>
                    Section 1.
                </h4>
                <section>
                    Amendments, deletions or additions to these bylaws must be approved by two-thirds (2/3) majority of the members present at any meeting of the members provided a quorum is present.
                </section>
                <h4>
                    Section 2.
                </h4>
                <section>
                    Revisions to these bylaws are effective on the date of ratification by the members.
                </section>
                <p>~ Revised March 2018</p>
            </StyledBylaws>
        )
    }
}
